import React, { useState } from 'react';
import { api } from '../context/AuthContext';

function FoodLogItem({ log, onDelete, onUpdate }) {
  const [editing, setEditing] = useState(false);
  const [quantity, setQuantity] = useState(log.quantity || 1);
  const [deleting, setDeleting] = useState(false);

  const displayCalories = Math.round((log.calories || 0) * (log.quantity || 1));

  const mealLabels = {
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    snack: 'Snack'
  };

  const handleDelete = async () => {
    if (!deleting) {
      setDeleting(true);
      return;
    }
    try {
      await api.delete(`/api/logs/${log.id}`);
      onDelete(log.id);
    } catch (err) {
      console.error('Delete failed:', err.message);
    }
    setDeleting(false);
  };

  const handleQuantitySubmit = async () => {
    const newQty = parseFloat(quantity);
    if (isNaN(newQty) || newQty <= 0) {
      setQuantity(log.quantity || 1);
      setEditing(false);
      return;
    }
    try {
      const res = await api.put(`/api/logs/${log.id}`, { quantity: newQty });
      onUpdate(res.data);
    } catch (err) {
      console.error('Update failed:', err.message);
    }
    setEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleQuantitySubmit();
    if (e.key === 'Escape') {
      setQuantity(log.quantity || 1);
      setEditing(false);
    }
  };

  return (
    <div className="food-log-item">
      <div className="food-log-main" onClick={() => setEditing(true)}>
        <div className="food-log-info">
          <span className="food-log-name">{log.food_name}</span>
          <span className="food-log-meta">
            {mealLabels[log.meal_type] || log.meal_type || ''}
            {log.serving_size && ` · ${log.serving_size}${log.serving_unit || 'g'}`}
            {' · '}
            {editing ? (
              <input
                className="quantity-input"
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                onBlur={handleQuantitySubmit}
                onKeyDown={handleKeyDown}
                autoFocus
                min="0.1"
                step="0.5"
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <span className="quantity-display">qty {log.quantity || 1}</span>
            )}
          </span>
        </div>
        <div className="food-log-calories">
          {displayCalories} cal
        </div>
      </div>
      <button
        className={`food-log-delete ${deleting ? 'confirm' : ''}`}
        onClick={handleDelete}
        title={deleting ? 'Tap again to confirm' : 'Delete'}
      >
        {deleting ? 'Sure?' : '\u00D7'}
      </button>
    </div>
  );
}

export default FoodLogItem;
